export const isAdminUser = (user) =>
  Boolean(user?.isAdmin || user?.role === "admin");

export const displayUserName = (user) =>
  user?.username ||
  [user?.firstName, user?.lastName].filter(Boolean).join(" ") ||
  user?.email ||
  "Unknown user";

export const filterAdminUsers = (
  users = [],
  { searchTerm = "", roleFilter = "", providerFilter = "" } = {}
) => {
  const query = searchTerm.trim().toLowerCase();
  return users.filter((user) => {
    const haystack = [
      user.username,
      user.email,
      user.firstName,
      user.lastName,
    ]
      .filter(Boolean)
      .join(" ")
      .toLowerCase();
    const matchesSearch = !query || haystack.includes(query);
    const admin = isAdminUser(user);
    const matchesRole =
      !roleFilter ||
      (roleFilter === "admin" && admin) ||
      (roleFilter === "user" && !admin);
    const matchesProvider = !providerFilter || user.provider === providerFilter;
    return matchesSearch && matchesRole && matchesProvider;
  });
};

export const toAdminUserRow = (user) => ({
  id: user._id,
  username: displayUserName(user),
  email: user.email,
  firstName: user.firstName,
  lastName: user.lastName,
  provider: user.provider || "local",
  role: isAdminUser(user) ? "Admin" : "User",
  createdAt: user.createdAt ? new Date(user.createdAt).getTime() : null,
  lastLogin: user.lastLogin ? new Date(user.lastLogin).getTime() : null,
  avatar: user.avatar,
  isAdmin: isAdminUser(user),
});

export const formatAdminDate = (value) =>
  value ? new Date(value).toLocaleDateString() : "—";

export const providerLabel = (provider) => {
  if (provider === "google") return "Google";
  if (provider === "local") return "Local";
  return provider || "Unknown";
};

export const adminRoleConfirmToken = (user) =>
  String(user?.email || user?.username || "").trim();

export const confirmationMatches = (typed, token) =>
  Boolean(token) && typed.trim().toLowerCase() === token.toLowerCase();

export const isSameUser = (left, right) =>
  left != null &&
  right != null &&
  String(left._id || left.id || left) === String(right._id || right.id || right);
